import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import getStrapiData from '../../../../integration/strapi';
import EirMetaTag from '../../../../components/eir-meta-tag/EirMetaTag';
import EirFooter from '../../../../components/eir-footer/EirFooter';
import EirHeader from '../../../../components/eir-header/EirHeader';
import handleAction from '../../../../components/shared/cta-actions/actionHandlers';
import PrepayMobileContainer from '../../../../components/eir-prepay/prepay-mobile/PrepayMobileContainer';
import Banner from '../../../../components/eir-prepay/prepay-banner/Banner';
import { clearAllCookies, getCookie } from '../../../../hooks/useCookie';

export async function getServerSideProps() {
  try {
    const cmsData = await getStrapiData('prepay-mobile');
    const cmsHeaderData = await getStrapiData('header');
    const cmsFooterData = await getStrapiData('footer');
    return {
      props: {
        cmsData: cmsData?.data || null,
        cmsHeaderData: cmsHeaderData || null,
        cmsFooterData: cmsFooterData || null,
      },
    };
  } catch (error) {
    console.error('Error fetching CMS data:', error);
    return {
      props: {
        cmsData: null,
        cmsHeaderData: null,
        cmsFooterData: null,
      },
    };
  }
}

/**
 * @name PrepayMobile
 * @description Page which loads prepay mobile journey
 * @param {object} cmsData - Strapi object for prepay-mobile
 * @param {object} cmsHeaderData - Strapi object for header
 * @param {object} cmsFooterData - Strapi object for footer
 * @returns {JSX.Element} - Returns Prepay Mobile Page
 */
const PrepayMobile = ({ cmsData, cmsHeaderData, cmsFooterData }) => {
  const router = useRouter();
  /**
   * @function handleActionWrapper
   * @description Handles function triggered on cta click
   * @param {string} action - Action type to perform
   * @param {URL} redirectUrl - URL provided in strapi
   */
  useEffect(() => {
    const hasReload = sessionStorage.getItem('hasReload');
    const hasReference = getCookie('PREPAY_REFERENCE');
    const currentPath = window.location.pathname;
    const isPrepapayPage = currentPath.includes('/shop/mobile/prepay');
    if (isPrepapayPage && hasReload === 'true') {
      sessionStorage.removeItem('hasReload');
    }

    if (!hasReference && !hasReload) {
      // If no prepay reference found clear all the stroage

      sessionStorage.setItem('hasReload', 'in-progress');
      clearAllCookies();
      localStorage.clear();
      window.location.reload();
    } else if (hasReference) {
      sessionStorage.removeItem('hasReload');
    } else if (hasReload === 'in-progress') {
      sessionStorage.setItem('hasReload', 'true');
    }
  }, []);

  const handleActionWrapper = (action, redirectUrl) => {
    handleAction(action, redirectUrl, router);
  };

  return (
    <>
      <EirMetaTag seo={cmsData?.attributes?.seoPrepayMobile} />
      <EirHeader cmsHeaderData={cmsHeaderData?.data} />
      <main id='main' tabIndex={-1}>
        <Banner cmsData={cmsData?.attributes?.prepayBanner} handleAction={handleActionWrapper} />
        <PrepayMobileContainer cmsData={cmsData} />
      </main>
      <EirFooter cmsFooterData={cmsFooterData?.data} />
    </>
  );
};

export default PrepayMobile;
